import "./socialmedia.scss"

function SocialMedia(props) {
    return (
        <div className="socialmedia">
            <a href="https://www.facebook.com/otgvon" target="_blank">
                <img src="https://www.freepnglogos.com/uploads/facebook-logo-icon/facebook-logo-icon-file-facebook-icon-svg-wikimedia-commons-4.png" className="fb" alt="" />
            </a>
            <a href="https://www.linkedin.com/in/karlvon" target="_blank">
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/640px-LinkedIn_logo_initials.png" className="lk" alt="" />
            </a>
            <a href="https://www.upwork.com/freelancers/~01f5069ca6dbdb410a" target="_blank">
                <img src="https://w7.pngwing.com/pngs/80/704/png-transparent-upwork-hd-logo.png" className="uw" alt="" />
            </a>
            <a href="https://profile.indeed.com/?hl=en_PH&co=PH&from=gnav-jobseeker-profile--profile-one-frontend" target="_blank">
                <img src="https://images.crunchbase.com/image/upload/c_lpad,f_auto,q_auto:eco,dpr_1/wafobb7hb5abdcgff3iv" className="in" alt="" />
            </a>
            <a href="https://myjobstreet.jobstreet.com.ph/resume/preview-resume.php?x=4fuuu910rqspkr71a9ht86png1" target="_blank">
                <img src="https://play-lh.googleusercontent.com/VEtVH7E1zpeaWzkgzg-CJ7pVeKJ-9l54tbCKDtfc9Gf5pyaKPeyztwaTc4xF-ou5VA" className="jb" alt="" />
            </a>
        </div>
    );
}

export default SocialMedia;